module.exports = __webpack_public_path__ + "static/loans_icon-3845fc63fd77b51b2d169ca3f9b6b440.png";